import "./StatusChangeBar.css";
import React from "react";

function StatusChangeBar(props) {
    
    function changeStep(step) {
        props.setActiveStatus(step)
        window.scrollTo(0, 0)
    }
    return (
        <div>
            <div className="row statusChangeBar">
                {props.steps.map((step, index) => (
                    <div key={index} className="statusItem" onClick={()=> changeStep(step)}>
                        <div className={props.activeStatus === step ? "circleStatusItem activeCircleStatusItem" : "circleStatusItem"}> </div>
                        <p className="statusBarText"> {step} </p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default StatusChangeBar;
